import { Role } from "../constants/enums";
import { ROUTES } from "../constants/routes";

export interface NavItem {
  to?: string;
  labelKey: string;
  roles?: Role[];
  children?: NavItem[];
}

// Nav structure with role-based access
export const allNav: NavItem[] = [
  { to: ROUTES.DASHBOARD, labelKey: "dashboard" },
  { to: ROUTES.BUSINESS_PLAN, labelKey: "businessPlan", roles: [Role.ADMIN] },
  {
    labelKey: "userManagement",
    children: [
      {
        to: ROUTES.ACTIVATE_DEACTIVATE_USERS,
        labelKey: "activateDeactivateUsers",
        roles: [Role.ADMIN],
      },
      {
        to: ROUTES.REFERRALS.MANUAL_APPROVAL,
        labelKey: "manualApproval",
        roles: [Role.ADMIN],
      },
      // {
      //   to: "/promote-user-to-moderator",
      //   labelKey: "promoteUserToModerator",
      //   roles: [Role.ADMIN],
      // },
      // { to: ROUTES.PROFILE, labelKey: "profile" },
    ],
  },
  {
    labelKey: "referrals",
    children: [
      // {
      //   to: ROUTES.REFERRALS.ADMIN.CONFIG,
      //   labelKey: "referralsConfig",
      //   roles: [Role.ADMIN],
      // },
      // {
      //   to: "/admin/referrals/analytics",
      //   labelKey: "referralsAnalytics",
      //   roles: [Role.ADMIN],
      // },
      // {
      //   to: ROUTES.REFERRALS.ADMIN.WITHDRAWALS,
      //   labelKey: "referralsWithdrawals",
      //   roles: [Role.ADMIN],
      // },
      // {
      //   to: "/admin/referrals/user-network",
      //   labelKey: "referralsUserNetwork",
      //   roles: [Role.ADMIN],
      // },
      {
        to: ROUTES.REFERRALS.FAMILY,
        labelKey: "family",
        roles: [Role.USER],
      },
      // {
      //   to: ROUTES.REFERRALS.MY_WITHDRAWALS,
      //   labelKey: "myWithdrawals",
      //   roles: [Role.USER],
      // },
    ],
  },
  {
    labelKey: "orders",
    children: [
      {
        to: ROUTES.ORDERS.ROOT,
        labelKey: "orderManagement",
        roles: [Role.USER],
      },
      {
        to: ROUTES.ORDERS.MY,
        labelKey: "myOrders",
        roles: [Role.USER],
      },
      {
        to: ROUTES.ORDERS.REGISTRATION,
        labelKey: "registrationOrders",
        roles: [Role.ADMIN],
      },
      {
        to: ROUTES.ORDERS.NORMAL,
        labelKey: "normalOrders",
        roles: [Role.ADMIN],
      },
      {
        to: ROUTES.ORDERS.DELETED,
        labelKey: "deletedOrders",
        roles: [Role.ADMIN],
      },
      {
        to: ROUTES.ORDERS.REFUND_REQUESTS,
        labelKey: "refundRequests",
        roles: [Role.ADMIN],
      },
    ],
  },
  {
    to: ROUTES.WALLET,
    labelKey: "wallet",
    roles: [Role.USER],
  },
  {
    labelKey: "products",
    children: [
      {
        to: ROUTES.PRODUCTS.MANAGE,
        labelKey: "manageProducts",
        roles: [Role.ADMIN],
      },
      {
        to: ROUTES.CATEGORIES.MANAGE,
        labelKey: "manageCategories",
        roles: [Role.ADMIN],
      },
      {
        to: ROUTES.SHIPPING.ZONES,
        labelKey: "manageShipping",
        roles: [Role.ADMIN],
      },
    ],
  },
  {
    labelKey: "dispatch",
    children: [
      {
        to: ROUTES.DISPATCH_MANAGEMENT,
        labelKey: "dispatchManagement",
        roles: [Role.ADMIN], // Admin only - full dispatch management
      },
    ],
  },
  {
    labelKey: "configuration",
    children: [
      {
        to: ROUTES.SYSTEM_CONFIG,
        labelKey: "systemConfig",
        roles: [Role.ADMIN],
      },
      {
        to: ROUTES.REFERRALS.ADMIN.CONFIG,
        labelKey: "referralsConfig",
        roles: [Role.ADMIN],
      },
      // {
      //   to: ROUTES.TAX_CONFIG,
      //   labelKey: "taxConfig",
      //   roles: [Role.ADMIN],
      // },
      {
        to: ROUTES.PUBLIC_CONTENT,
        labelKey: "publicContent",
        roles: [Role.ADMIN],
      },
    ],
  },
  // {
  //   labelKey: "compliance",
  //   children: [
  //     {
  //       to: ROUTES.KYC.USER,
  //       labelKey: "myKyc",
  //       roles: [Role.USER],
  //     },
  //     {
  //       to: ROUTES.KYC.ADMIN,
  //       labelKey: "adminKyc",
  //       roles: [Role.ADMIN],
  //     },
  //   ],
  // },
  // {
  //   labelKey: "returnsRefunds",
  //   children: [
  //     {
  //       to: ROUTES.RETURNS.USER,
  //       labelKey: "myReturns",
  //       roles: [Role.USER],
  //     },
  //     {
  //       to: ROUTES.RETURNS.ADMIN,
  //       labelKey: "adminReturns",
  //       roles: [Role.ADMIN],
  //     },
  //   ],
  // },
  // {
  //   to: ROUTES.INVOICES.USER,
  //   labelKey: "myInvoices",
  //   roles: [Role.USER],
  // },
  // {
  //   to: ROUTES.COMMISSION_BONUSES.USER,
  //   labelKey: "myBonuses",
  //   roles: [Role.USER],
  // },
  // {
  //   to: ROUTES.COMMISSION_BONUSES.ADMIN,
  //   labelKey: "adminBonuses",
  //   roles: [Role.ADMIN],
  // },
  // {
  //   to: ROUTES.SUPPORT.USER,
  //   labelKey: "support",
  //   roles: [Role.USER],
  // },
  // {
  //   to: ROUTES.SUPPORT.ADMIN,
  //   labelKey: "adminSupport",
  //   roles: [Role.ADMIN],
  // },
  // {
  //   to: ROUTES.LOGS,
  //   labelKey: "logs",
  //   roles: [Role.ADMIN],
  // },
  {
    labelKey: "commissions",
    children: [
      // {
      //   to: ROUTES.COMMISSIONS.MY,
      //   labelKey: "myCommissions",
      //   roles: [Role.USER],
      // },
      {
        to: ROUTES.COMMISSIONS.ALL,
        labelKey: "allCommissions",
        roles: [Role.ADMIN],
      },
      {
        to: ROUTES.COMMISSIONS.PAYMENT_HISTORY,
        labelKey: "paymentHistory",
        roles: [Role.ADMIN],
      },
      // {
      //   to: ROUTES.COMMISSIONS.TEAM,
      //   labelKey: "teamCommissions",
      //   roles: [Role.ADMIN],
      // },
      // {
      //   to: ROUTES.COMMISSIONS.ANALYTICS,
      //   labelKey: "commissionAnalytics",
      //   roles: [Role.ADMIN],
      // },
    ],
  },
  // {
  //   labelKey: "donations",
  //   children: [
  //     { to: "/donations", labelKey: "donations", roles: [Role.USER] },
  //     {
  //       to: "/admin-donations",
  //       labelKey: "adminDonations",
  //       roles: [Role.ADMIN],
  //     },
  //   ],
  // },
  // {
  //   labelKey: "emergency",
  //   children: [
  //     {
  //       to: "/emergency-withdrawals",
  //       labelKey: "emergencyWithdrawals",
  //       roles: [Role.USER],
  //     },
  //     {
  //       to: "/admin-emergency-withdrawals",
  //       labelKey: "adminEmergencyWithdrawals",
  //       roles: [Role.ADMIN],
  //     },
  //   ],
  // },
  // {
  //   labelKey: "payments",
  //   children: [
  //     {
  //       to: ROUTES.MANAGE_PAYMENTS,
  //       labelKey: "managePayments",
  //       roles: [Role.ADMIN],
  //     },
  //   ],
  // },
  // {
  //   labelKey: "analytics",
  //   children: [
  //     {
  //       to: ROUTES.ADMIN_ANALYTICS,
  //       labelKey: "adminAnalytics",
  //       roles: [Role.ADMIN],
  //     },
  //     {
  //       to: ROUTES.TEAM_ANALYTICS,
  //       labelKey: "teamAnalytics",
  //       roles: [Role.ADMIN],
  //     },
  //     {
  //       to: ROUTES.COMMISSIONS.ANALYTICS,
  //       labelKey: "commissionAnalytics",
  //       roles: [Role.ADMIN],
  //     },
  //   ],
  // },
  // {
  //   labelKey: "commissions",
  //   children: [
  //     { to: "/commissions/my", labelKey: "myCommissions" },
  //     {
  //       to: "/commissions/all",
  //       labelKey: "allCommissions",
  //       roles: [Role.ADMIN],
  //     },
  //     {
  //       to: "/commissions/team",
  //       labelKey: "teamCommissions",
  //       roles: [Role.ADMIN],
  //     },
  //     {
  //       to: "/commissions/analytics",
  //       labelKey: "commissionAnalytics",
  //       roles: [Role.ADMIN],
  //     },
  //   ],
  // },
  // {
  //   to: "/dispatch-management",
  //   labelKey: "dispatchManagement",
  //   roles: [Role.ADMIN],
  // },
  // { to: "/manage-payments", labelKey: "managePayments", roles: [Role.ADMIN] },
  // { to: "/admin-analytics", labelKey: "analytics", roles: [Role.ADMIN] },
  // { to: "/logs", labelKey: "logs", roles: [Role.ADMIN] },
];
